import React from "react";
import { NavLink } from "react-router-dom";

import "./WebDevelopmentContentStyles.css";

import JMCArchive from "../assets/JMC-project.png";
import SSSArchive from "../assets/SSS-project.png";
import DataUploader from "../assets/Uploader-project.png";
import ODV from "../assets/odv-project.png";
import AMS from "../assets/ams-project.png";
import DMS from "../assets/dms-project.png";
import EFORMS from "../assets/eforms-project.png";
import MIS from "../assets/mis-project.png";
import LAP from "../assets/LAP-project.png";

const WebDevelopmentContent = () => {
  return (
    <div>
      <div className="container-col-2">
        <div className="left-container">
          <img className="image-size" src={LAP} />
        </div>
        <div className="right-container">
          <h1>Listing Activity Portal</h1>
          <p>        
          Listing Activity Portal (LAP) is a sophisticated web-based system tailored for efficient online data collection, data sharing, budget management, and approval workflows. Seamlessly integrated with SAP, it offers a customizable, flexible, and accessible solution for modern business needs.
          </p>
          <NavLink
            to="https://tap.flyacecorp.com:30003"
            className="link-button"
            target="_blank"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={MIS} />
        </div>
        <div className="right-container">
          <h1>Merchandising Information System</h1>
          <p>        
          Merchandising Information System (MIS) is a technology-based tool that helps businesses manage and analyze information related to their products. It aids in decision-making by providing insights into inventory, sales, pricing, and customer preferences, ultimately optimizing merchandising processes.
          </p>
          <NavLink
            to="https://mis.flyacecorp.com:30001"
            className="link-button"
            target="_blank"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={EFORMS} />
        </div>
        <div className="right-container">
          <h1>e-Forms (Weekly Expenses Portal)</h1>
          <p>        
          Improved the existing weekly expenses portal by seamlessly integrating it with the SAP system. Previously, the portal operated independently, necessitating users to manually encode data into SAP to ensure synchronization. The enhancement enables the portal to directly connect to the SAP system, automating user data encoding whenever a transaction occurs and preventing redundancy. This achievement was realized through the creation and utilization of an API, facilitating communication between the portal and SAP for streamlined operations.
          </p>
          <NavLink
            to="https://eforms.flyacecorp.com:8089/"
            className="link-button"
            target="_blank"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={DMS} />
        </div>
        <div className="right-container">
          <h1>Distributor Management System</h1>
          <p>
          Developed an advanced management system enabling comprehensive tracking of the company's distributors, encompassing overall sell-out, inventory, stocks, plans, sales, returns, and customer data. This system features exportable reports for in-depth analytics and incorporates user controls to tailor permissions based on management requirements. This represents an improvement upon a prior distributor management system designed as a desktop application by earlier teams. The limitation of the former system required separate installations for each distributor, each with its own database. Consequently, the IT department had to regularly back up individual databases for analytical processing, proving cumbersome as the distributor count increased over the years. In response, a web-based Distributor Management System has been introduced to address these challenges.
          </p>
          <NavLink
            to="https://dms.flyacecorp.com:30000/"
            className="link-button"
            target="_blank"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={AMS} />
        </div>
        <div className="right-container">
          <h1>Central Access Management System</h1>
          <p>
          Created a Centralized Access Management system to enhance the efficiency of user account administration, eliminating the need for redundant user creation across various in-house applications, thereby preventing multiple user access points. The application employs Microsoft API for user authentication and access control, enabling administrators to easily grant users access to specific applications as needed. Additionally, administrators have the capability to temporarily or permanently disable a user's access to all permissions granted, providing comprehensive control over user privileges.
          </p>
          <NavLink
            to="#"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Private Access
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={ODV} />
        </div>
        <div className="right-container">
          <h1>Order to Delivery Validation System</h1>
          <p>
          Created a specialized application for the Fly Ace Sales Department, facilitating seamless order-to-delivery management for key accounts like SM, Robinsons, and Puregold. The application employs Microsoft API for user authentication and access control. It incorporates automated file conversion and upload services, streamlining the process of transferring data from the Accounts Portal to the System. Notably, users can now monitor orders and deliveries in real-time, providing a proactive approach to prevent theft and address any anomalies that may occur before or during product deliveries.
          </p>
          <NavLink
            to="#"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Private Access
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={DataUploader} />
        </div>
        <div className="right-container">
          <h1>Data Uploader Application</h1>
          <p>
            Developed an application for Fly Ace BICS Department that caters data management with the following features:
          </p>
          <p><b>Security</b>: Utilized by Microsoft API for user authentication and access control.</p>
          <p><b>Scalability and Performance</b>: Designed to handle large file uploads efficiently, considering scalability and performance optimizations to ensure a smooth user experience.</p>
          <p><b>File Selection and Upload</b>: Allow users to easily select and upload files from their local devices with a user-friendly file selection interface.</p>
          <NavLink
            to="#"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Private Access
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={JMCArchive} />
        </div>
        <div className="right-container">
          <h1>Jose Mari Chan Media Archive System</h1>
          <p>
          TVCXpress Manila Inc. conceptualized a mockup design for Jose Mari Chan's Media Archive System. I then translated this design into a functional archive system, aligning it with TVCXpress Manila Inc.'s vision to showcase the system's capabilities to Jose Mari Chan.
          </p>
          <NavLink
            to="https://tvcxpress-jmc.000webhostapp.com/"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={SSSArchive} />
        </div>
        <div className="right-container">
          <h1>SSS Archiving System</h1>
          <p>
          SSS Archiving System is a locally hosted web application developed by Mr. Karl Magtanong, with my assistance as the Project Manager. This application was developed to meet specific archiving needs, incorporating advanced features to streamline data management and retrieval within a controlled environment. The project involved detailed planning, coding, testing, and iterative improvements, resulting in a reliable and user-friendly solution tailored to the initial project requirements.
          </p>
          <NavLink
            to="https://www.figma.com/proto/428yOHsh1WOmmKeUGXTJDk/SSS-Archiving-System?node-id=1-2&scaling=min-zoom&page-id=0%3A1"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default WebDevelopmentContent;
